// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"731bd101","277":"c0f15162","402":"7fc5ef0b","457":"894cab60","514":"16b7177e","637":"c914e0fe","799":"54637ef8","949":"456d2518"}[chunkId] + ".chunk.js";
};